import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import games, { featuredAppIds } from "../data/gamesData";
import { logEvent } from "../firebase";
import "./HomeHero.css";

export default function HomeHero() {
  const { t } = useTranslation();

  const heroApps = featuredAppIds
    .slice(0, 4)
    .map((id) => games.find((app) => app.id === id))
    .filter(Boolean);

  return (
    <section className="home-hero">
      <div className="home-hero-inner">
        <div className="home-hero-content">
          <span className="home-hero-badge">{t("hero_badge")}</span>
          <h1 className="home-hero-title">{t("hero_title")}</h1>
          <p className="home-hero-subtitle">{t("hero_subtitle")}</p>

          <div className="home-hero-actions">
            <Link
              to="/apps"
              className="home-btn home-btn-primary"
              onClick={() =>
                logEvent("our_apps_button_clicked", { location: "hero" })
              }
            >
              {t("browse_apps")}
            </Link>
            <Link to="/support" className="home-btn home-btn-secondary">
              {t("contact_us")}
            </Link>
          </div>

          <p className="home-hero-note">{t("available_on")}</p>
        </div>

        <div className="home-hero-icons" aria-hidden="true">
          {heroApps.map((app) => (
            <Link
              key={app.id}
              to={`/apps/${app.id}`}
              className="home-hero-icon-link"
              tabIndex={-1}
            >
              <img src={app.icon} alt="" />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
